/**
 * Survey launcher factory for Web SDK
 */
import { Api, Utils } from "@ms-ofb/officefloodgatecore";
import CoachingUXLauncherFactory from "./CoachingUXLauncherFactory";
import RudeSurveyLauncherFactory from "./RudeSurveyLauncherFactory";
import * as Configuration from "../Configuration/Configuration";
const {
  isNOU
} = Utils;
export default class AdaptiveSurveyLauncherFactory {
  constructor(rudeSurveyLauncherFactory, coachingUXLauncherFactory) {
    this.rudeSurveyLauncherFactory = rudeSurveyLauncherFactory;
    this.coachingUXLauncherFactory = coachingUXLauncherFactory;
  }
  static make() {
    return new AdaptiveSurveyLauncherFactory(new RudeSurveyLauncherFactory(), new CoachingUXLauncherFactory());
  }
  makeSurveyLauncher(survey) {
    if (isNOU(survey)) {
      return null;
    }
    switch (survey.getLauncherType().toLocaleLowerCase()) {
      case CoachingUXLauncherFactory.LAUNCHER_TYPE:
        return this.makeGenericMessagingSurfaceLauncher(survey);
      case RudeSurveyLauncherFactory.LAUNCHER_TYPE:
      default:
        return this.makeRudeSurveyLauncher(survey);
    }
  }
  AcceptsSurvey(survey) {
    if (isNOU(survey)) {
      return false;
    }
    switch (survey.getType()) {
      case Api.ISurvey.Type.GenericMessagingSurface:
        return !isNOU(this.coachingUXLauncherFactory) && this.coachingUXLauncherFactory.AcceptsSurvey(survey);
      default:
        return Configuration.get().checkIfSurveysEnabled() && !isNOU(this.rudeSurveyLauncherFactory) && this.rudeSurveyLauncherFactory.AcceptsSurvey(survey);
    }
  }
  makeGenericMessagingSurfaceLauncher(survey) {
    if (!isNOU(this.coachingUXLauncherFactory)) {
      return this.coachingUXLauncherFactory.makeSurveyLauncher(survey);
    }
    return null;
  }
  makeRudeSurveyLauncher(survey) {
    if (!isNOU(this.rudeSurveyLauncherFactory)) {
      return this.rudeSurveyLauncherFactory.makeSurveyLauncher(survey);
    }
    return null;
  }
}